import { useId } from 'react';

import { type IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ApprovalFillProps = IconComponentBaseProps;

export const ApprovalFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ApprovalFillProps) => {
  const maskId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M6.30775 20.7307C5.80908 20.7307 5.38308 20.5541 5.02975 20.2007C4.67658 19.8476 4.5 19.4217 4.5 18.923V15.5C4.5 14.9948 4.675 14.5672 5.025 14.2172C5.375 13.8672 5.80258 13.6922 6.30775 13.6922H17.6923C18.1974 13.6922 18.625 13.8672 18.975 14.2172C19.325 14.5672 19.5 14.9948 19.5 15.5V18.923C19.5 19.4217 19.3234 19.8476 18.9703 20.2007C18.6169 20.5541 18.1909 20.7307 17.6923 20.7307H6.30775ZM6.923 17.2307H17.077C17.341 17.2307 17.5608 17.1429 17.7365 16.9672C17.9122 16.7916 18 16.5717 18 16.3077V16.1152C18 15.8641 17.909 15.6474 17.727 15.4652C17.5448 15.2832 17.3282 15.1922 17.077 15.1922H6.923C6.67183 15.1922 6.45517 15.2832 6.273 15.4652C6.091 15.6474 6 15.8641 6 16.1152V16.3077C6 16.5717 6.08783 16.7916 6.2635 16.9672C6.43917 17.1429 6.659 17.2307 6.923 17.2307ZM11.2615 12.677L7.9365 8.08848C7.79933 7.89098 7.70158 7.67748 7.64325 7.44798C7.58492 7.21865 7.57242 6.9834 7.60575 6.74223C7.78008 5.6154 8.26275 4.69073 9.05375 3.96823C9.84492 3.2459 10.827 2.88474 12 2.88474C13.173 2.88474 14.1551 3.2459 14.9462 3.96823C15.7372 4.69073 16.2199 5.6154 16.3943 6.74223C16.4276 6.9834 16.4151 7.21865 16.3568 7.44798C16.2984 7.67748 16.2007 7.89098 16.0635 8.08848L12.7385 12.677C12.5577 12.9282 12.3115 13.0537 12 13.0537C11.6885 13.0537 11.4423 12.9282 11.2615 12.677Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
